<div class="flex items-center justify-center gap-2">
    <span class="icon-chevron-up cursor-pointer" [class.opacity-0]="readonly" (click)="increment()"></span>
    <input
        type="number"
        [max]="max"
        [min]="0"
        [formControl]="input"
        (change)="handleChange($event)"
        (keydown)="preventNonNumericInput($event)"
        [ariaLabel]="ariaLabel"
        class="w-10 text-center text-font-primary text-base border border-shs-gray-2 bg-transparent rounded-sm [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none focus:outline-none focus:ring focus:ring-shs-orange focus:border-shs-orange/50"
    />
    @if (readonly) {
    <span class="icon-circle-checkmark"></span>
    } @else {
    <span class="icon-chevron-down cursor-pointer" (click)="decrement()"></span>
    }
</div>
